import style from "./AdvicesBlock.module.scss";
import MainBlob from "../../../animate/MainBlob";
import useLazyVideo from "../../../../utils/hooks/useLazyVideo";

function AdvicesBlock({ dictionary }) {
	const [containerRef, videoRef, isInView] = useLazyVideo();

	const ADVICES_DATA = [
		{ name: dictionary["People on the foreground"] || "People on the foreground", body: dictionary["our service process the best files with people"] },
		{ name: dictionary["No hectic movements"] || "No hectic movements", body: dictionary["Try to upload videos where people stand/sit still"] || "Try to upload videos where people stand/sit still" },
		{
			name: dictionary["No crossing objects"] || "No crossing objects",
			body: dictionary["Please, check that there are no crossing objects on the foreground distracting AI from the object"] || "Please, check that there are no crossing objects on the foreground",
		},
		{
			name: dictionary["No people in action"] || "No people in action",
			body:
				dictionary["When the person is doing sports, dancing, running or jumping it is quite difficult for our AI to detect its contours"] ||
				"When the person is in action it is quite difficult for our AI to detect its contours",
		},

		{
			name: dictionary["portrait_videos"] || "Portrait videos",
			body: dictionary["Check that  people on your photos and videos are filmed waist-high"] || "Check that people on your photos and videos are filmed waist-high",
		},
		{
			name: dictionary["Clear silhouette"] || "Clear silhouette",
			body: dictionary["Upload videos with clear contours of the foreground object"] || "Upload videos with clear contours of the foreground object",
		},
	];

	return (
		<section ref={containerRef} className={style.section}>
			<h2 className={style.title}>{dictionary["Advice to get the best result"]}</h2>
			<div className={style.content}>
				<div className={style.videoContainer}>
					<video ref={videoRef} className={style.video} autoPlay={isInView} loop muted playsInline preload="none" poster="/video/advices_preview.webp">
						<source src="/video/advices_block.mp4" type="video/mp4" />
					</video>
				</div>
				<div className={style.text}>
					{ADVICES_DATA.map((advice) => {
						return (
							<div key={advice.name} className={style.item}>
								<p className={style.advice}>{advice.name}</p>
								<p className={style.description}>{advice.body}</p>
							</div>
						);
					})}
				</div>
			</div>
			<MainBlob isBlur={true} />
		</section>
	);
}

export default AdvicesBlock;
